// Notification Messages
// ERROR MESSAGES
export const WEIGHT_LIMIT_ERROR_MSG = 'Price Intelligence currently supports 1 to 30 carat weight diamonds only';
export const SUPPORT_COLOR_ERROR_MSG = 'Our data currently supports only Yellow, Pink and Blue color categories';
export const PRICE_INTESITY_ERROR_MSG = (intensity ='', key='') => `Price intelligence does not supports ${intensity} ${key} at the moment`;